module.exports = __webpack_public_path__ + "7de4714e9b39f8bfdacd5a1f8ba96795.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-gradient.svg
// module id = 349
// module chunks = 0